import { EmailDialogComponent } from './../content/home/components/email-dialog/email-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DeniedDialogComponent } from './components/denied-dialog/denied-dialog.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [AlertDialogComponent, ConfirmDialogComponent, DeniedDialogComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    DeniedDialogComponent
    
  ]
})
export class GlpCommonModule { }
